<template>
  <div>
    <qd-steps
      v-model="activeStep"
      :stepsItems="stepsItems"
      :has-navigation="false"
      :destroy-on-hide="true"
      :animated="true"
      class="step_expanded title-normal mb-0"
      type="is-addOrEdit"
      size="is-medium">
      <template #impression>
        <step-impression :commande="commande" />
      </template>
    </qd-steps>
  </div>
</template>

<script>
import StepImpression from '@/components/commande/logistiqueImpression/stepImpression';

export default {
  props: {
    commande: {
      type: Object,
      required: true,
    },
  },
  components: {
    StepImpression,
  },
  data() {
    return {
      activeStep: 'impression',
    };
  },
  computed: {
    stepsItems() {
      const steps = ['visuel', 'impression', 'faconnage', 'expedition'];
      return steps.map((step) => ({
        name: step,
        value: step,
        label: this.$t(`editionCommande.logistiqueImpression.${step}`),
        icon: this.activeStep === step ? 'check-bold' : '',
        clickable: ['impression'].includes(step),
        headerClass: 'subtitle is-5',
      }));
    },
  },
};
</script>
